import React from 'react';
import { IconProps } from '.';

const SvgPrinter = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M19.5 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 16.25h6v1.5H9v-1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M17.5 2.5h-11V6h-5v12h4v3.5h13V18h4V6h-5V2.5Zm1 14H21v-9H3v9h2.5v-4h13v4ZM7 20h10v-6H7v6Zm9-14V4H8v2h8Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPrinter;
